const ModelLoadingStatus = {
    LOADING: "LOADING",
    LOADED: "LOADED",
    ERROR: "ERROR",
}

export default ModelLoadingStatus
